import runner from "./app-runner";

void runner();
